/**
 * 项目所需组件自定义配置
 */
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { trackMap } from '@/utils/tracer/track_map'
import { exposeMap } from '@/utils/tracer/expose_map.js'
import { projectConfig } from '@/utils/tracer/project_config.js'
import { baseParams } from '@/utils/tracer/base_params.js'

import { vuePlugin } from '@mc/mc-jsbridge'

import Url from '@mc/mc-utils/js/url/url'
import { miniProgramEnv, appVersion, thirdSource } from '@/defines/environment'
import { companyId } from '@/defines/user'
import { userInfo } from '@/utils/user'

const initConfig = {
  // 组件库配置
  VueTrack: {
    context: tracerVuePlugin,
    params: {
      trackMap,
      exposeMap,
      autoInit: false,
      projectConfig,
      baseParams
    }
  },
  JsBridge: {
    context: vuePlugin,
    customConfig: {
      nativeNav: false
    }
  },
  hackFixInit: true,
  remInit: true
}

const updateTracer = () => {
  const queryParams = new Url(window.location.href).parseQuerystring()
  tracerVuePlugin.init(projectConfig, baseParams)
  tracerVuePlugin.updateParam({
    uid: queryParams.company_id || companyId,
    city_id: queryParams.city_id || baseParams.city_id,
    area_id: queryParams.area_id || baseParams.area_id,
    latitude: queryParams.latitude || baseParams.latitude,
    longitude: queryParams.longitude || baseParams.longitude,
    app_system: miniProgramEnv.isWechatMiniProgram
      ? 'wxmp'
      : miniProgramEnv.isAlipayMiniProgram
      ? 'alimp'
      : baseParams.app_system,
    app_version: queryParams.app_version || appVersion,
    device_id: queryParams.device_id || baseParams.device_id,
    os_version: queryParams.os_version || baseParams.os_version || '',
    tid: baseParams.tid || '',
    commonParams: {
      third_source: thirdSource.thirdSource,
      third_source_content: thirdSource.thirdSourceContent,
      scene: queryParams.mp_scene || '',
      mall_type: String(userInfo.mallType)
    }
  })
}

export { initConfig, updateTracer }
